export function commonCommonSdk(): string {
  return 'common-common-sdk';
}
